import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 11,
	viewBox: "0 0 17 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.244 1.34242L15.7199 0.855514C15.5552 0.702397 15.3356 0.618164 15.1012 0.618164C14.8668 0.618164 14.6471 0.702397 14.4824 0.855514L7.11815 7.69709L2.51704 3.42237C2.35236 3.2695 2.13265 3.18515 1.89824 3.18515C1.66397 3.18515 1.44439 3.2695 1.27958 3.42237L0.75535 3.90916C0.590537 4.06252 0.5 4.26676 0.5 4.48429C0.5 4.70194 0.590537 4.90605 0.75535 5.05917L5.95028 9.88521C5.95717 9.89427 5.96446 9.90273 5.97291 9.91047L6.49714 10.3894C6.66182 10.5419 6.88153 10.6182 7.11776 10.6182H7.12049C7.35502 10.6182 7.57473 10.5419 7.73915 10.3894L8.26351 9.90624C8.27197 9.8985 8.27912 9.8921 8.28341 9.88557L16.2439 2.49074C16.5853 2.17423 16.5853 1.65929 16.244 1.34242Z",
		fill: "#1CB954"
	})
});
export default SvgCheckmark;
